import { useState } from "react"
import {
	IconCubeOutline18 as Box,
	IconCheckDoubleOutline18 as CheckCheck,
} from "nucleo-ui-outline-18"

import type { IconType } from "@productlane/ui"
import { Button, Popover } from "@productlane/ui"

import type { ConvertTagKind } from "./convert-tag-copy"
import { convertTagDescription } from "./convert-tag-copy"

const KINDS: { kind: ConvertTagKind; label: string; Icon: IconType }[] = [
	{ kind: "project", label: "Project", Icon: Box },
	{ kind: "issue", label: "Issue", Icon: CheckCheck },
]

interface ConvertTagActionsProps {
	threadCount: number | undefined
	onConvert: (kind: ConvertTagKind) => void
}

export const ConvertTagActions = ({
	threadCount,
	onConvert,
}: ConvertTagActionsProps) => {
	const [open, setOpen] = useState<ConvertTagKind | null>(null)

	return (
		<div className="flex items-center gap-1">
			<div className="mr-1.5 truncate text-xs text-secondary">Convert to</div>
			{KINDS.map(({ kind, label, Icon }) => (
				<Popover
					key={kind}
					align="end"
					className="p-3"
					open={open === kind}
					onOpenChange={(value) => setOpen(value ? kind : null)}
					content={
						<div
							data-testid={`convert-tag-${kind}-confirm`}
							className="flex flex-col gap-2.5"
						>
							<div className="text-[13px] font-medium text-primary">
								Convert to Linear {kind}
							</div>
							<p className="text-xs leading-[18px] text-secondary">
								{convertTagDescription(kind, threadCount)}
							</p>
							<div className="flex justify-end gap-1.5">
								<Button variant="ghost" onClick={() => setOpen(null)}>
									Cancel
								</Button>
								<Button
									onClick={() => {
										setOpen(null)
										onConvert(kind)
									}}
								>
									Continue
								</Button>
							</div>
						</div>
					}
				>
					<Button
						Icon={Icon}
						variant="ghost"
						className="pr-0 sm:pr-2.5"
						aria-label={`Convert to ${kind}`}
					>
						<span className="hidden sm:inline">{label}</span>
					</Button>
				</Popover>
			))}
		</div>
	)
}
